// Feature is loosely defined by something we would market on a pricing page
// These values are used for translation keys as well
export const AD_RETARGETING = 'adRetargeting';
export const LIVE_CHAT = 'liveChat';
export const CONVERSATIONAL_BOTS = 'conversationalBots';
export const TEAM_EMAIL = 'teamEmail';
export const CONVERSATIONS_INBOX = 'conversationsInbox';
export const FORMS = 'forms';
export const AD_MANAGEMENT = 'adManagement';
export const GOOGLE_SEARCH_CONSOLE_INTEGRATION = 'googleSearchConsoleIntegration';
export const REPORTING_DASHBOARDS = 'reportingDashboards';
export const TEAMS = 'teams';
export const MOBILE_OPTIMIZATION = 'mobileOptimization';
export const PHONE_SUPPORT = 'phoneSupport';
export const STANDARD_CONTACT_SCORING = 'standardContactScoring';
export const ONE_TO_ONE_EMAIL = '1to1Email';
export const ALL_CRM_FEATURES = 'allCrmFeatures';
export const CALLING_SDK = 'callingSdk';
export const STRIPE_INTEGRATION = 'stripeIntegration';
export const EMAIL_MARKETING = 'emailMarketing';
export const LIST_SEGMENTATION = 'listSegmentation';
export const SOCIAL_MEDIA = 'socialMedia';
export const CALLS_TO_ACTION = 'callsToAction';
export const LANDING_PAGES = 'landingPages';
export const SSL_CERTIFICATE = 'sslCertificate';
export const OMNI_CHANNEL_MARKETING_AUTOMATION = 'omniChannelMarketingAutomation';
export const SALESFORCE_INTEGRATION = 'salesforceIntegration';
export const SALESFORCE_CUSTOM_OBJECT_SYNC = 'salesforceCustomObjectSync';
export const WEBSITE_TRAFFIC_ANALYTICS = 'websiteTrafficAnalytics';
export const CAMPAIGN_REPORTING = 'campaignReporting';
export const ATTRIBUTION_REPORTING = 'attributionReporting';
export const AB_TESTING = 'abTesting';
export const CUSTOM_REPORTS = 'customReports';
export const PREDICTIVE_LEAD_SCORING = 'predictiveLeadScoring';
export const KNOWLEDGE_BASE_SINGLE_SIGN_ON = 'knowledgeBaseSingleSignOn';
export const SINGLE_SIGN_ON = 'singleSignOn';
export const PARTITIONING = 'partitioning';
export const CONTENT_PARTITIONING = 'contentPartitioning';
export const FACEBOOK_MESSENGER = 'facebookMessenger';
export const YOUTUBE_INTEGRATION = 'youtubeIntegration';
export const FILTERED_ANALYTICS_VIEW = 'filteredAnalyticsView';
export const EMAIL_SEND_FREQUENCY_CAP = 'emailSendFrequencyCap';
export const EMAIL_TRACKING_NOTIFICATIONS = 'emailTrackingNotifications';
export const EMAIL_SCHEDULING = 'emailScheduling';
export const SNIPPETS = 'snippets';
export const CALLING = 'calling';
export const SEQUENCES = 'sequences';
export const MEETINGS = 'meetings';
export const REP_PRODUCTIVITY_PERFORMANCE = 'repProductivityPerformance';
export const EMAIL_SUPPORT = 'emailSupport';
export const DEAL_PIPELINE = 'dealPipeline';
export const PRODUCTS = 'products';
export const SIMPLE_AUTOMATION = 'simpleAutomation';
export const SIMPLE_TICKET_AUTOMATION = 'simpleTicketAutomation';
export const SALES_AUTOMATION = 'salesAutomation';
export const AUTOMATIC_LEAD_ROTATION = 'automaticLeadRotation';
export const REQUIRED_FIELDS = 'requiredFields';
export const QUOTES = 'quotes';
export const SMART_SEND_TIMES = 'smartSendTimes';
export const MULTI_CURRENCY = 'multiCurrency';
export const VIDEO_CREATION = 'videoCreation';
export const VIDEO_CREATION_AND_HOSTING = 'videoCreationAndHosting';
export const RECURRING_REVENUE_TRACKING = 'recurringRevenueTracking';
export const GOALS = 'goals';
export const ESIGN = 'eSign';
export const WORKFLOWS_EXTENSIONS = 'workflowsExtensions';
export const CUSTOM_BOTS = 'customBots';
export const SLACK = 'slack';
export const VIDEO_HOSTING_MANAGEMENT = 'videoHostingManagement';
export const PLAYBOOKS = 'playbooks';
export const TICKETING = 'ticketing';
export const CUSTOMER_SERVICE_AUTOMATION = 'customerServiceAutomation';
export const TEMPLATES = 'templates';
export const DOCUMENTS = 'documents';
export const CONVERSATION_ROUTING = 'conversationRouting';
export const KNOWLEDGE_BASE = 'knowledgeBase';
export const HIERARCHICAL_TEAMS = 'hierarchicalTeams';
export const CALCULATED_PROPERTIES = 'calculatedProperties';
export const WEBHOOKS = 'webhooks';
export const CUSTOM_CODED_BOT_ACTIONS = 'customCodedBotActions';
export const TICKET_STATUS = 'ticketStatus';
export const TICKET_ROUTING = 'ticketRouting';
export const TASK_AUTOMATION = 'taskAutomation';
export const MULTIPLE_TICKET_PIPELINES = 'multipleTicketPipelines';
export const INSIGHTS_DASHBOARD = 'insightsDashboard';
export const AGENT_PRESENCE = 'agentPresence';
export const HUB_DB_DYNAMIC_CONTENT = 'hubDbDynamicContent';
export const WEBSITE_PAGES = 'websitePages';
export const DESIGN_MANAGER = 'designManager';
export const STAGING_ENVIRONMENT = 'stagingEnvironment';
export const WEBSITE_ANALYTICS = 'websiteAnalytics';
export const CUSTOM_DOMAINS = 'customDomains';
export const UPTIME = 'uptime';
export const CONTENT_DELIVERY_NETWORK = 'contentDeliveryNetwork';
export const CONTACT_MANAGEMENT = 'contactManagement';
export const CONTACT_WEBSITE_ACTIVITY = 'contactWebsiteActivity';
export const COMPANIES = 'companies';
export const DEALS = 'deals';
export const TASKS_AND_ACTIVITIES = 'tasksAndActivities';
export const COMPANY_INSIGHTS = 'companyInsights';
export const GMAIL_AND_OUTLOOK_INTEGRATION = 'gmailAndOutlookIntegration';
export const HUBSPOT_CONNECT_INTEGRATIONS = 'hubspotConnectIntegrations';
export const CUSTOM_SUPPORT_FORM_FIELDS = 'customSupportFormFields';
export const PROSPECTS = 'prospects';
export const MESSENGER_INTEGRATION = 'messengerIntegration';
export const ADAPTIVE_TESTING = 'adaptiveTesting';
export const MULTI_TOUCH_REVENUE_ATTRIBUTION = 'multiTouchRevenueAttribution';
export const RECORD_CUSTOMIZATION = 'recordCustomization';
export const CUSTOM_PROPERTIES = 'customProperties';
export const BLOG = 'blog';
export const DRAG_AND_DROP_EDITOR = 'dragAndDropEditor';
export const CONTACT_ATTRIBUTION_REPORT_BUILDER = 'contactAttributionReportBuilder';
export const SEO_RECOMMEND_OPTIMIZE = 'seoRecommendOptimize';
export const SEO_ANALYTICS = 'seoAnalytics';
export const BUILT_IN_AMP_SUPPORT = 'builtInAmpSupport';
export const WEBSITE_THEMES = 'websiteThemes';
export const LOCAL_WEBSITE_DEVELOPMENT = 'localWebsiteDevelopment';
export const ADVANCED_MENUS = 'advancedMenus';
export const APP_AND_ASSET_MARKETPLACE = 'appAndAssetMarketplace';
export const PASSWORD_PROTECTED_PAGES = 'passwordProtectedPages';
export const MULTI_LANGUAGE_CREATION_TESTING = 'multiLanguageCreationTesting';
export const CONTENT_STRATEGY = 'contentStrategy';
export const CONTENT_STAGING = 'contentStaging';
export const SUBDOMAIN_AND_COUNTRY_CODE_TLD = 'subdomainAndCountryCodeTLD';
export const SITE_EXPORT = 'siteExport';
export const BLOG_IMPORT = 'blogImport';
export const URL_MAPPINGS = 'urlMappings';
export const CDN = 'cdn';
export const TWENTY_FOUR_SEVEN_SECURITY_MONITORING = '247securityMonitoring';
export const MEMBERSHIPS = 'memberships';
export const ADDITIONAL_BRAND_DOMAIN = 'additionalBrandDomain';
export const ADDITIONAL_ROOT_DOMAINS = 'additionalRootDomains';
export const MULTI_DOMAIN_TRAFFIC_REPORTING = 'multiDomainTrafficReporting';
export const CODE_ALERTS = 'codeAlerts';
export const REVERSE_PROXY_CONFIGURATION = 'reverseProxyConfiguration';
export const CUSTOM_DOMAIN_SECURITY_SETTINGS = 'customDomainSecuritySettings';
export const SITE_PERFORMANCE_MONITORING = 'sitePerformanceMonitoring';
export const ACTIVITY_LOGGING = 'activityLogging';
export const WEB_APPS = 'webApps';
export const TARGET_ACCOUNTS_HOME = 'targetAccountsHome';
export const COMPANY_SCORING = 'companyScoring';
export const ACCOUNT_OVERVIEW = 'accountOverview';
export const FIELD_LEVEL_PERMISSIONS = 'fieldLevelPermissions';
export const ADVANCED_PERMISSIONS = 'advancedPermissions';
export const CUSTOM_OBJECTS = 'customObjects';
export const MOBILE_APP = 'mobileApp';
export const TASK_QUEUES = 'taskQueues';
export const SALES_ANALYTICS = 'salesAnalytics';
export const EMAIL_HEALTH_INSIGHTS = 'emailHealthInsights';
export const MULTI_LANGUAGE_CONTENT = 'multiLanguageContent';
export const LEAD_AND_COMPANY_SCORING = 'leadAndCompanyScoring';
export const ABM_TOOLS_AND_AUTOMATION = 'abmToolsAndAutomation';
export const ADS_OPTIMIZATION_EVENTS = 'adsOptimizationEvents';
export const PROGRAMMABLE_CHATBOTS = 'programmableChatbots';
export const BEHAVIORAL_EVENT_TRIGGERS = 'behavioralEventTriggersAndReporting';
export const EMAIL_COMPARISON_REPORTING = 'emailComparisonReporting';
export const LOGGED_IN_VISITOR_IDENTIFICATION = 'loggedInVisitorIdentification';
export const MULTI_LANGUAGE_KNOWLEDGE_BASE = 'multiLanguageKnowledgeBase';
export const FORECASTING = 'forecasting';
export const CUSTOM_BEHAVIORAL_EVENTS = 'customBehavioralEvents';
export const CONVERSATION_INTELLIGENCE = 'conversationIntelligence';
export const CUSTOM_FIELD_MAPPINGS = 'customFieldMappings';
export const PROGRAMMABLE_AUTOMATION = 'programmableAutomation';
export const DATA_QUALITY_AUTOMATION = 'dataQualityAutomation';
export const DUPLICATE_MANAGEMENT = 'duplicateManagement';
export const BULK_DUPLICATE_MANAGEMENT = 'bulkDuplicateManagement';
export const DATA_SYNC = 'dataSync';
export const HISTORICAL_SYNC = 'historicalSync';
export const DEFAULT_FIELD_MAPPINGS = 'defaultFieldMappings';
export const APP_MARKETPLACE_INTEGRATIONS = 'appMarketplaceIntegrations';
export const ADMIN_NOTIFICATIONS_MANAGEMENT = 'adminNotificationsManagement';
export const SITE_TREE = 'siteTree';
export const DYNAMIC_PERSONALIZATION = 'dynamicPersonalization';
export const PERSONALIZATION_TOKENS = 'personalizationTokens';
export const COLLABORATION_TOOLS = 'collaborationTools';
export const MARKETING_EVENTS_OBJECT = 'marketingEventsObject';
export const HUBDB = 'hubDB';
export const EMAIL_REPLY_TRACKING = 'emailReplyTracking';
export const EMAIL_HEALTH_REPORTING = 'emailHealthReporting';
export const CAMPAIGN_MANAGEMENT = 'campaignManagement';
export const TECHNICAL_SUPPORT = 'technicalSupport';
export const PREMIUM_HOSTING = 'premiumHosting';
export const WEB_APPLICATION_FIREWALL = 'webApplicationFirewall';
export const SMART_CONTENT_AND_REPORTING = 'smartContentAndReporting';
export const WEBSITE_STRUCTURE_IMPORT = 'websiteStructureImport';
export const TASK_CALENDAR_SYNC = 'taskCalendarSync';
export const CUSTOM_SURVEYS = 'customSurveys';
export const SANDBOXES = 'sandboxes';
export const DATASETS = 'datasets';
export const ADVANCED_DATA_CALCULATIONS = 'advancedDataCalculations';
export const SNOWFLAKE_DATA_SHARE = 'snowflakeDataShare';
export const CHANNEL_SWITCHING = 'channelSwitching';
export const USER_MANAGEMENT = 'userManagement';
export const CUSTOM_USER_PERMISSIONS = 'customUserPermissions';
export const LOGIN_AS_ANOTHER_USER = 'loginAsAnotherUser';
export const PERMISSION_SETS = 'permissionSets';
export const PAYMENTS = 'payments';
export const SCHEDULED_WORKFLOW_TRIGGERS = 'scheduledWorkflowTriggers';
export const CUSTOMER_PORTAL = 'customerPortal';
export const POST_CHAT_FEEDBACK = 'postChatFeedback';
export const MOBILE_INBOX = 'mobileInbox';
export const CUSTOM_VIEWS_SHARED_INBOX = 'customViewsSharedInbox';
export const SLAS = 'slas';
export const SERVICE_ANALYTICS = 'serviceAnalytics';
export const CUSTOMER_FEEDBACK_SURVEYS = 'customerFeedbackSurveys';
export const ASSOCIATION_LABELS = 'associationLabels';
export const HS_PHONE_NUMBERS = 'hubSpotPhoneNumbers';
export const CALL_TRANSCRIPTION_AND_COACHING = 'callTranscriptionAndCoaching';
export const EMAIL_AUTOMATION = 'emailAutomation';
export const FORM_AUTOMATION = 'formAutomation';
export const BLOG_EXPORT = 'blogExport';
export const AUTO_GENERATED_XML_SITEMAP = 'autoGeneratedXMLSitemap';
export const APEX_HOSTING_AND_REDIRECTS = 'apexHostingAndRedirects';
export const CUSTOM_GOALS = 'customGoals';
export const DATA_QUALITY_COMMAND_CENTER = 'dataQualityCommandCenter';
export const DATA_HEALTH_TRENDS = 'dataHealthTrends';
export const AI_POWERED_DATA_FORMATTING_RECOMMENDATIONS = 'AIPowereddataFormattingRecs';
export const WHATS_APP_INTEGRATION = 'whatsAppIntegration';
export const SALES_CONTENT_ANALYTICS = 'salesContentAnalytics';
export const PRESETS = 'presets';
export const CUSTOMER_JOURNEY_ANALYTICS = 'customerJourneyAnalytics'; // Ideally we shouldn't export this, but some place might still import this the wrong way

export default {
  AD_RETARGETING,
  LIVE_CHAT,
  CONVERSATIONAL_BOTS,
  TEAM_EMAIL,
  CONVERSATIONS_INBOX,
  FORMS,
  AD_MANAGEMENT,
  GOOGLE_SEARCH_CONSOLE_INTEGRATION,
  REPORTING_DASHBOARDS,
  TEAMS,
  MOBILE_OPTIMIZATION,
  PHONE_SUPPORT,
  STANDARD_CONTACT_SCORING,
  ONE_TO_ONE_EMAIL,
  ALL_CRM_FEATURES,
  CALLING_SDK,
  STRIPE_INTEGRATION,
  EMAIL_MARKETING,
  LIST_SEGMENTATION,
  SOCIAL_MEDIA,
  CALLS_TO_ACTION,
  LANDING_PAGES,
  SSL_CERTIFICATE,
  OMNI_CHANNEL_MARKETING_AUTOMATION,
  SALESFORCE_INTEGRATION,
  SALESFORCE_CUSTOM_OBJECT_SYNC,
  WEBSITE_TRAFFIC_ANALYTICS,
  CAMPAIGN_REPORTING,
  ATTRIBUTION_REPORTING,
  AB_TESTING,
  CUSTOM_REPORTS,
  PREDICTIVE_LEAD_SCORING,
  KNOWLEDGE_BASE_SINGLE_SIGN_ON,
  SINGLE_SIGN_ON,
  PARTITIONING,
  CONTENT_PARTITIONING,
  FACEBOOK_MESSENGER,
  YOUTUBE_INTEGRATION,
  FILTERED_ANALYTICS_VIEW,
  EMAIL_SEND_FREQUENCY_CAP,
  EMAIL_TRACKING_NOTIFICATIONS,
  EMAIL_SCHEDULING,
  SNIPPETS,
  CALLING,
  SEQUENCES,
  MEETINGS,
  REP_PRODUCTIVITY_PERFORMANCE,
  EMAIL_SUPPORT,
  DEAL_PIPELINE,
  PRODUCTS,
  SIMPLE_AUTOMATION,
  SIMPLE_TICKET_AUTOMATION,
  SALES_AUTOMATION,
  AUTOMATIC_LEAD_ROTATION,
  REQUIRED_FIELDS,
  QUOTES,
  SMART_SEND_TIMES,
  MULTI_CURRENCY,
  VIDEO_CREATION,
  VIDEO_CREATION_AND_HOSTING,
  RECURRING_REVENUE_TRACKING,
  GOALS,
  ESIGN,
  WORKFLOWS_EXTENSIONS,
  CUSTOM_BOTS,
  SLACK,
  VIDEO_HOSTING_MANAGEMENT,
  PLAYBOOKS,
  TICKETING,
  CUSTOMER_SERVICE_AUTOMATION,
  TEMPLATES,
  DOCUMENTS,
  CONVERSATION_ROUTING,
  KNOWLEDGE_BASE,
  HIERARCHICAL_TEAMS,
  CALCULATED_PROPERTIES,
  WEBHOOKS,
  CUSTOM_CODED_BOT_ACTIONS,
  TICKET_STATUS,
  TICKET_ROUTING,
  TASK_AUTOMATION,
  MULTIPLE_TICKET_PIPELINES,
  INSIGHTS_DASHBOARD,
  AGENT_PRESENCE,
  HUB_DB_DYNAMIC_CONTENT,
  WEBSITE_PAGES,
  DESIGN_MANAGER,
  STAGING_ENVIRONMENT,
  WEBSITE_ANALYTICS,
  CUSTOM_DOMAINS,
  UPTIME,
  CONTENT_DELIVERY_NETWORK,
  CONTACT_MANAGEMENT,
  CONTACT_WEBSITE_ACTIVITY,
  COMPANIES,
  DEALS,
  TASKS_AND_ACTIVITIES,
  COMPANY_INSIGHTS,
  GMAIL_AND_OUTLOOK_INTEGRATION,
  HUBSPOT_CONNECT_INTEGRATIONS,
  CUSTOM_SUPPORT_FORM_FIELDS,
  PROSPECTS,
  MESSENGER_INTEGRATION,
  ADAPTIVE_TESTING,
  MULTI_TOUCH_REVENUE_ATTRIBUTION,
  RECORD_CUSTOMIZATION,
  CUSTOM_PROPERTIES,
  BLOG,
  DRAG_AND_DROP_EDITOR,
  CONTACT_ATTRIBUTION_REPORT_BUILDER,
  SEO_RECOMMEND_OPTIMIZE,
  SEO_ANALYTICS,
  BUILT_IN_AMP_SUPPORT,
  WEBSITE_THEMES,
  LOCAL_WEBSITE_DEVELOPMENT,
  ADVANCED_MENUS,
  APP_AND_ASSET_MARKETPLACE,
  PASSWORD_PROTECTED_PAGES,
  MULTI_LANGUAGE_CREATION_TESTING,
  CONTENT_STRATEGY,
  CONTENT_STAGING,
  SUBDOMAIN_AND_COUNTRY_CODE_TLD,
  SITE_EXPORT,
  BLOG_IMPORT,
  URL_MAPPINGS,
  CDN,
  TWENTY_FOUR_SEVEN_SECURITY_MONITORING,
  MEMBERSHIPS,
  ADDITIONAL_BRAND_DOMAIN,
  ADDITIONAL_ROOT_DOMAINS,
  MULTI_DOMAIN_TRAFFIC_REPORTING,
  CODE_ALERTS,
  REVERSE_PROXY_CONFIGURATION,
  CUSTOM_DOMAIN_SECURITY_SETTINGS,
  SITE_PERFORMANCE_MONITORING,
  ACTIVITY_LOGGING,
  WEB_APPS,
  TARGET_ACCOUNTS_HOME,
  COMPANY_SCORING,
  ACCOUNT_OVERVIEW,
  FIELD_LEVEL_PERMISSIONS,
  ADVANCED_PERMISSIONS,
  CUSTOM_OBJECTS,
  MOBILE_APP,
  TASK_QUEUES,
  SALES_ANALYTICS,
  EMAIL_HEALTH_INSIGHTS,
  MULTI_LANGUAGE_CONTENT,
  LEAD_AND_COMPANY_SCORING,
  ABM_TOOLS_AND_AUTOMATION,
  ADS_OPTIMIZATION_EVENTS,
  PROGRAMMABLE_CHATBOTS,
  BEHAVIORAL_EVENT_TRIGGERS,
  EMAIL_COMPARISON_REPORTING,
  LOGGED_IN_VISITOR_IDENTIFICATION,
  MULTI_LANGUAGE_KNOWLEDGE_BASE,
  FORECASTING,
  CUSTOM_BEHAVIORAL_EVENTS,
  CONVERSATION_INTELLIGENCE,
  CUSTOM_FIELD_MAPPINGS,
  PROGRAMMABLE_AUTOMATION,
  DATA_QUALITY_AUTOMATION,
  DUPLICATE_MANAGEMENT,
  BULK_DUPLICATE_MANAGEMENT,
  DATA_SYNC,
  HISTORICAL_SYNC,
  DEFAULT_FIELD_MAPPINGS,
  APP_MARKETPLACE_INTEGRATIONS,
  ADMIN_NOTIFICATIONS_MANAGEMENT,
  SITE_TREE,
  DYNAMIC_PERSONALIZATION,
  PERSONALIZATION_TOKENS,
  COLLABORATION_TOOLS,
  MARKETING_EVENTS_OBJECT,
  HUBDB,
  EMAIL_REPLY_TRACKING,
  EMAIL_HEALTH_REPORTING,
  CAMPAIGN_MANAGEMENT,
  TECHNICAL_SUPPORT,
  PREMIUM_HOSTING,
  WEB_APPLICATION_FIREWALL,
  SMART_CONTENT_AND_REPORTING,
  WEBSITE_STRUCTURE_IMPORT,
  TASK_CALENDAR_SYNC,
  CUSTOM_SURVEYS,
  SANDBOXES,
  DATASETS,
  ADVANCED_DATA_CALCULATIONS,
  SNOWFLAKE_DATA_SHARE,
  CHANNEL_SWITCHING,
  USER_MANAGEMENT,
  CUSTOM_USER_PERMISSIONS,
  LOGIN_AS_ANOTHER_USER,
  PERMISSION_SETS,
  PAYMENTS,
  SCHEDULED_WORKFLOW_TRIGGERS,
  CUSTOMER_PORTAL,
  POST_CHAT_FEEDBACK,
  MOBILE_INBOX,
  CUSTOM_VIEWS_SHARED_INBOX,
  SLAS,
  SERVICE_ANALYTICS,
  CUSTOMER_FEEDBACK_SURVEYS,
  ASSOCIATION_LABELS,
  HS_PHONE_NUMBERS,
  CALL_TRANSCRIPTION_AND_COACHING,
  EMAIL_AUTOMATION,
  FORM_AUTOMATION,
  BLOG_EXPORT,
  AUTO_GENERATED_XML_SITEMAP,
  APEX_HOSTING_AND_REDIRECTS,
  CUSTOM_GOALS,
  DATA_QUALITY_COMMAND_CENTER,
  DATA_HEALTH_TRENDS,
  AI_POWERED_DATA_FORMATTING_RECOMMENDATIONS,
  WHATS_APP_INTEGRATION,
  SALES_CONTENT_ANALYTICS,
  PRESETS,
  CUSTOMER_JOURNEY_ANALYTICS
};